// Tooltips
export const NO_AVAILABLE_SUBSCRIPTIONS_TO_REPLACE =
  'No Available Subscriptions To Replace'
export const NO_AVAILABLE_SUBSCRIPTIONS_TO_ASSIGN =
  'No Available Subscriptions To Assign'
export const NO_FREE_USERS_TO_REPLACE = 'No Unsubscribed Users To Replace'
export const NO_EMPTY_PLACE_IN_PLAN =
  'No users to add. All users have been assigned a subscription. You can invite more users to your account by sharing the referral link.'
export const NO_FREE_USERS_TO_ADD =
  'No users to add. All users have been assigned a subscription. You can invite more users to your account by sharing the referral link'
export const YOU_CAN_NOT_REMOVE_USER_WITH_SUBSCRIPTION =
  'You Can Not Remove User With Subscription'
export const UPDATE_DATA = 'Update Data'
// Action Buttons
export const ADD_USERS = 'Add Users'
export const ADD_SUBSCRIPTION = 'Add Subscription'
export const REPLACE_USER = 'Replace User'
export const REPLACE_SUBSCRIPTION = 'Replace Subscription'
export const REMOVE_USER = 'Remove User'
export const CANCEL = 'Cancel'
export const CLOSE = 'Close'
export const CONFIRM = 'Confirm'
// Referal
export const CREATE_REFERAL_LINK = 'Create Referral Link'
export const LINK_VALID = 'Link valid'
export const LESS_THAN = 'less than'
// Tabs
export const MANAGE_SUBSCRIPTIONS = 'Manage Subscriptions'
export const MANAGE_USERS = 'Manage Users'
export const ACCOUNTS_BILLING = 'Accounts & Billing'
export const NO_DATA_SEARCH = 'No Data Search'
// Form
export const USER_EAMIL = 'User email'
export const PLAN = 'Plan'
export const SUBSCRIPTION = 'Subscription'
export const REMOVE_FILTERS = 'remove filters'
// Table
export const SUBSCRIPTIONS = 'Subscriptions'
export const ASSIGNED_USERS = 'Assigned Users'
export const ACTIONS = 'Actions'
export const ASSIGNED = 'Assigned'
export const TOTAL = 'Total'
export const NO_ASSIGNED_USERS = 'No Assigned Users'
export const PRICE = 'Price'
export const QUANTITY = 'Quantity'
export const MONTHS = 'Months'
export const AMOUNT = 'Amount'
// Modals
export const CURRENT_SUBSCRIPTION = 'Current Subscription'
export const REMOVE_SUBSCRIPTION = 'Remove Subscription'
export const USER = 'User'
export const SUBSCRIPTIONS_AVAILABLE = 'Subscriptions Available'
export const SHOW_SELECTED_VALUES = 'Show Selected Values'
export const AVAILABLE = 'Available'
export const REMOVE_SESCRIPTION_TEXT =
  'Deleting this user will remove them from your Account. They will retain their login but will not be able to be assigned a subscription from your account. You can invite the user again by using the referral link.'
export const CURRENT_USER = 'Current User'
export const NEW_USER = 'New User'

export const REPLACE_USER_DESCRIPTION = (newUser, user) =>
  `<b>${newUser?.email}</b> will retain the subscription & projects from <b>${user.email}</b>.<br />Payment and subscription duration remains the same for the subscription.`

export const UNSUBSCRIBE_USERS_DESCRIPTION_1 = (userEmail, subscription) =>
  `By removing <b>${userEmail}</b> from <b style="text-transform: capitalize;">${subscription}</b>, this subscription will be available to assign to another user. The current user will retain their first created project but will lose their other projects. They will no longer have a subscription and have limited features.`

export const UNSUBSCRIBE_USERS_DESCRIPTION_2 = (userEmail) =>
  `You can transfer the projects from <b>${userEmail}</b> to another user by Replacing the user from the Manage Subscription page.`
// Billing Tab
export const PAYPAL = 'Paypal'
export const CREDIT_CARD_LAST_NUMBERS = (lastNum) =>
  `Credit card ending in ${lastNum}`
// Invoices
export const EAMIL = 'Email'
export const PAST_BILL_DATE = 'Past Bill Date'
export const BILLING_DETAILS = 'Billing Details'
export const PAST_BILLEND_AMOUNT = 'Past Billed Amount'
export const CREATED_AT = 'Created at'
export const PAID_AT = 'Paid at'
export const AMAOUNT_TO_APID = 'Amout to paid'
export const PAID_AMOUNT = 'Paid amount'
export const DESCRIPTION = 'Description'
export const ADMINISTRATOR_ACCOUNT_DETAILS = 'Administrator Account Details'
export const EXPIRATION_DATE = 'Expiration Date'
export const INVOICE = 'Invoice'
export const STATE = 'State'
export const INVOICE_PENDING =
  'Invoice has been created and is awaiting payment'
export const INVOICE_PAID =
  'Invoice paid, time needed to generate additional information'
export const MODAL_CONTENT = {
  enterpriseUser: {
    title: 'Please contact your administrator',
    text: 'You are unable to make any purchases on your <b>account</b>. Please contact your administrator to make any edits to your subscription.',
  },
  enterpriseAdmin: {
    title: 'Please contact Ubersuggest',
    text: 'You are unable to make any purchases on your <b>account</b>. Please contact Ubersuggest operations team to make any edits to your subscriptions.',
  },
}
